import Vue from 'vue'
import axios from 'axios'
import router from '../../router'

import * as types from '../types'

const state = {
  token: localStorage.getItem('token') || null,
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  passwordChanged: null,
  // Login.vue
  loginFailed: false,
  loginBusy: false,
  loginError: false,
  // ForgotPassword.vue
  forgotPasswordStatus: null,
  forgotPasswordBusy: false,
  // ResetPassword.vue
  passwordResetStatus: null,
  passwordResetBusy: false
}

const getters = {
  user: (state) => {
    return state.user
  },
  isAuthenticated: (state) => {
    return state.token !== null
  },
  loginFailed: (state) => {
    return state.loginFailed
  },
  loginBusy: (state) => {
    return state.loginBusy
  },
  loginError: (state) => {
    return state.loginError
  },
  forgotPasswordStatus: (state) => {
    return state.forgotPasswordStatus
  },
  forgotPasswordBusy: (state) => {
    return state.forgotPasswordBusy
  },
  passwordResetStatus: (state) => {
    return state.passwordResetStatus
  },
  passwordResetBusy: (state) => {
    return state.passwordResetBusy
  },
  passwordChanged: (state) => {
    return state.passwordChanged
  }
}

const mutations = {
  [types.MUTATE_LOGGED_IN_USER]: (state, userData) => {
    state.token = userData.token
    state.user = userData.user
  },
  [types.MUTATE_CLEAR_AUTH]: (state) => {
    Vue.set(state, 'token', null)
    Vue.set(state, 'user', null)
    state.token = null
    state.user = null
  },
  [types.MUTATE_LOGIN_FAILED]: (state, status) => {
    state.loginFailed = status
  },
  [types.MUTATE_LOGIN_BUSY]: (state, status) => {
    state.loginBusy = status
  },
  [types.MUTATE_LOGIN_ERROR]: (state, loginError) => {
    state.loginError = loginError
  },
  [types.MUTATE_FORGOT_PASSWORD_STATUS]: (state, status) => {
    state.forgotPasswordStatus = status
  },
  [types.MUTATE_FORGOT_PASSWORD_BUSY]: (state, status) => {
    state.forgotPasswordBusy = status
  },
  [types.MUTATE_PASSWORD_RESET_STATUS]: (state, status) => {
    state.passwordResetStatus = status
  },
  [types.MUTATE_PASSWORD_RESET_BUSY]: (state, status) => {
    state.passwordResetBusy = status
  },
  [types.MUTATE_PASSWORD_CHANGED]: (state, status) => {
    state.passwordChanged = status
  }
}

const actions = {
  [types.CHANGE_PASSWORD]: ({ commit, dispatch }, authData) => {
    axios
      .post('/password/change', {
        old_password: authData.oldPassword,
        password: authData.password,
        password_confirmation: authData.confirmPassword
      })
      .then(res => {
        commit(types.MUTATE_PASSWORD_CHANGED, {
          'message': res.data.message,
          'success': true
        })
      })
      .catch(error => {
        // We need to let the user know his reset failed
        commit(types.MUTATE_PASSWORD_CHANGED, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
  },
  [types.LOGIN]: ({ commit, dispatch }, authData) => {
    commit(types.MUTATE_LOGIN_BUSY, true)
    commit(types.MUTATE_LOGIN_ERROR, false)

    axios
      .post('/auth/login', {
        email: authData.email,
        password: authData.password
      })
      .then(res => {
        // Store the details in our local storage
        localStorage.setItem('token', res.data.access_token)
        localStorage.setItem('user', JSON.stringify(res.data.user))
        localStorage.setItem('expirationDate', res.data.expires_at)

        // Store the details in vuex
        commit(types.MUTATE_LOGGED_IN_USER, {
          token: res.data.access_token,
          user: res.data.user
        })
      })
      .catch(error => {
        // We need to let the user know his login failed
        commit(types.MUTATE_LOGIN_ERROR, error)
        commit(types.MUTATE_LOGIN_FAILED, true)
      })
      .finally(() => {
        commit(types.MUTATE_LOGIN_BUSY, false)
      })
  },
  [types.CLEAR_AUTH]: ({ commit }) => {
    commit(types.MUTATE_CLEAR_AUTH)
    // Clear local storage
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  },
  [types.LOGOUT]: ({ commit }) => {
    commit(types.MUTATE_CLEAR_AUTH)
    // Clear local storage
    localStorage.clear()
    // Clear vuex
    router.go()
  },
  [types.FORGOT_PASSWORD]: ({ commit }, authData) => {
    commit(types.MUTATE_FORGOT_PASSWORD_BUSY, true)

    axios
      .post('/password/forgot', {
        email: authData.email
      })
      .then(res => {
        commit(types.MUTATE_FORGOT_PASSWORD_STATUS, {
          'message': res.data.message,
          'success': true
        })
      })
      .catch(error => {
        // We need to let the user know his reset failed
        commit(types.MUTATE_FORGOT_PASSWORD_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_FORGOT_PASSWORD_BUSY, false)
      })
  },
  [types.RESET]: ({ commit, dispatch }, authData) => {
    commit(types.MUTATE_PASSWORD_RESET_BUSY, true)

    axios
      .post('/password/reset', {
        email: authData.email,
        token: authData.token,
        password: authData.password,
        password_confirmation: authData.password_confirmation
      })
      .then(res => {
        commit(types.MUTATE_PASSWORD_RESET_STATUS, {
          'message': res.data.message,
          'success': true
        })

        // Redirect the user to the login page
        localStorage.setItem('openLogin', true)
        setTimeout(() => {
          router.replace('/')
        }, 2000)
      })
      .catch(error => {
        // We need to let the user know his reset failed
        commit(types.MUTATE_PASSWORD_RESET_STATUS, {
          'message': error.response ? error.response.data.message : error.message,
          'success': false
        })
      })
      .finally(() => {
        commit(types.MUTATE_PASSWORD_RESET_BUSY, false)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
